<template>
  <div class="wt-radio wt2-sg -custom-css">
    <wt-radio-text
      :value="radioValue"
      :buttons="buttons"
      :disabled="field.disabled"
      @select="changeRadioValue"
    >
      <div class="-radio-header" slot="header">
        <div class="-label-box" v-if="field.label">
          <span>{{ field.label }}</span>
        </div>
        <slot name="tooltip"></slot>
      </div>
    </wt-radio-text>
  </div>
</template>

<script>
import fieldsMixin from '../mixins/fields.vue';

export default {
  props: {
    field: {
      type: Object,
      required: true,
      validator(value) {
        return _.every(['optionThumbnails', 'defaultValue'], (prop) =>
          _.includes(_.keys(value), prop)
        );
      },
    },
  },

  mixins: [fieldsMixin],

  data() {
    return {
      radioValue: null,
    };
  },

  created() {
    this.radioValue = _.isDefined(this.field.value)
      ? this.field.value
      : this.field.defaultValue ||
        (this.field.optionThumbnails &&
          this.field.optionThumbnails.length &&
          this.field.optionThumbnails[0].id);

    this.emitChange({ newValue: this.radioValue, makeDirty: false });

    this.$watch('radioValue', (newValue) => {
      this.emitChange({ newValue });
    });
  },

  mounted() {
    this.fieldReadyNextTick();
  },

  methods: {
    changeRadioValue(radioValue) {
      this.radioValue = radioValue;
    },
  },

  computed: {
    buttons() {
      return _(this.field.optionThumbnails)
        .map((button) => {
          return {
            text: button.label || button.id,
            value: button.id,
            icon: null,
          };
        })
        .value();
    },
  },
};
</script>
